<template>
  <div class="header-wrapper">
    <header class="app-header navbar">
      <!-- Mobile Menu Toggle -->
      <button
        class="navbar-toggler d-lg-none"
        type="button"
        @click="mobileSidebarToggle"
      >
        <i class="fa fa-bars" />
      </button>

      <!-- Brand Logo -->
      <div class="navbar-brand">
        <img
          src="/static/img/logo_final_3.png"
          alt="Experto Retail"
          class="brand-logo"
        >
      </div>

      <!-- Desktop Navigation -->
      <b-navbar-nav class="desktop-nav d-none d-lg-flex">
        <HeaderDropdownCommercial
          :data="userModules"
          class="nav-link"
        />
        <HeaderDropdownTradeMarketing
          :data="userModules"
          class="nav-link"
        />
        <!-- Crear Reporte Button -->
        <!-- <b-nav-item
          class="header-btn report-creator"
          @click.prevent="handleCreateReport"
          href="#"
        >
          <i class="fa fa-file-text-o" />
          <span class="btn-text">Crear Reporte</span>
        </b-nav-item> -->
      </b-navbar-nav>

      <!-- Mobile Navigation Collapse -->
      <b-collapse
        id="nav-collapse"
        v-model="isNavCollapsed"
        class="mobile-collapse"
      >
        <div class="mobile-menu">
          <HeaderDropdownCommercial :data="userModules" />
          <HeaderDropdownTradeMarketing :data="userModules" />
          <div class="mobile-menu-divider" />
          <div
            class="mobile-menu-item"
            @click="$router.push('/workspaces'); isNavCollapsed = false"
          >
            <i class="mobile-menu-icon fa fa-cube" />
            <span>Escenarios</span>
            <span
              v-if="workspaceLoaded"
              class="status-dot success ml-1"
            />
          </div>
          <div
            class="mobile-menu-item"
            @click="showSalesStatusModal = true; isNavCollapsed = false"
          >
            <i class="mobile-menu-icon fa fa-database" />
            <span>Estado de Carga</span>
          </div>
          <div
            v-if="isAdmin"
            class="mobile-menu-item"
            @click="$router.push('/admin'); isNavCollapsed = false"
          >
            <i class="mobile-menu-icon fa fa-cog" />
            <span>Admin</span>
          </div>
        </div>
      </b-collapse>

      <!-- Right Side Actions (desktop only) -->
      <div class="header-actions ml-auto d-none d-lg-flex">
        <!-- Workspaces -->
        <!-- <div
          v-b-tooltip.hover
          class="header-btn"
          :title="workspaceLoaded ? `Escenario: ${activeWorkspace.name}` : 'Configurar escenarios'"
          @click="$router.push('/workspaces')"
        >
          <i class="fa fa-cube" />
          <span class="btn-text">Escenarios</span>
          <span
            v-if="workspaceLoaded"
            class="status-dot success"
          />
        </div> -->

        <!-- Data Warehouse Status -->
        <DwStatusButton @click="showSalesStatusModal = true" />

        <!-- Admin -->
        <div
          v-if="isAdmin"
          class="header-btn admin"
          @click="$router.push('/admin')"
        >
          <i class="fa fa-cog" />
          <span class="btn-text">Admin</span>
        </div>
      </div>

      <!-- Account Dropdown (always visible) -->
      <HeaderDropdownAccntCustom
        key="main-account-dropdown"
        class="nav-link account-nav ml-auto"
        :class="{ 'ml-0': false }"
      />
    </header>
    <SalesStatusModal
      :show="showSalesStatusModal"
      @update:show="val => showSalesStatusModal = val"
      @hide="showSalesStatusModal = false"
      @reset="handleModalReset"
    />
  </div>
</template>

<script>
import HeaderDropdownAccntCustom from './HeaderDropdownAccntCustom.vue'
import HeaderDropdownTradeMarketing from './HeaderDropdownTradeMarketing.vue'
import HeaderDropdownCommercial from './HeaderDropdownCommercial.vue'
import DwStatusButton from './components/DwStatusButton.vue'
import SalesStatusModal from './components/SalesStatusModal.vue'
import webSocketMessageHandler from '@/services/WebSocketMessageHandler'
import { general } from '@/services/api/ExpertoRetail'

export default {
  name: 'BaseHeader',
  components: {
    HeaderDropdownAccntCustom,
    HeaderDropdownTradeMarketing,
    HeaderDropdownCommercial,
    DwStatusButton,
    SalesStatusModal
  },
  data () {
    return {
      lastDwUpdate: null,
      dwJobLoading: false,
      dwJobProgress: 0,
      dwJobError: null,
      isNavCollapsed: false,
      dwStatusInterval: null,
      showSalesStatusModal: false,
      // Notificaciones ETL: evitan toasts duplicados / históricos
      lastEtlStatus: null,
      etlNotificationsReadyAt: 0
    }
  },
  computed: {
    isAdmin () {
      return this.$store.getters.isAdmin
    },
    activeWorkspace () {
      return this.$store.state.desktopParameterConfig ? this.$store.state.desktopParameterConfig.activeWorkspace : null
    },
    activeWorkspaceTooltip () {
      return this.activeWorkspace ? `Escenario Activado: ${this.activeWorkspace.name}` : ''
    },
    workspaceLoaded () {
      return this.activeWorkspace !== null
    },
    contractModules () {
      return this.$store.getters.contractModules
    },
    userModules () {
      return this.$store.getters.userModules || []
    }
  },
  watch: {
    '$route.name' (newRoute) {
      if (newRoute === 'clientTermsAcceptance') {
        this.showSalesStatusModal = false
      }
    }
  },
  mounted () {
    // Al conectar tras el login el backend reenvía los últimos eventos ETL.
    // Durante esta ventana solo sincronizamos estado, sin notificar, para no
    // mostrar toasts de procesos que ocurrieron antes de iniciar sesión.
    this.etlNotificationsReadyAt = Date.now() + 5000
    webSocketMessageHandler.on('dwEtlJobUpdate', this.handleEtlJobUpdate)
    this.fetchInitialDwStatus()
    this.startDwStatusCheck()
    if (this.$route.name !== 'clientTermsAcceptance' && !sessionStorage.getItem('salesStatusShown')) {
      this.showSalesStatusModal = true
      sessionStorage.setItem('salesStatusShown', '1')
    }
  },
  beforeDestroy () {
    webSocketMessageHandler.off('dwEtlJobUpdate', this.handleEtlJobUpdate)
    this.stopDwStatusCheck()
  },
  methods: {
    sidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-hidden')
    },
    mobileSidebarToggle () {
      this.isNavCollapsed = !this.isNavCollapsed
    },
    goTo (view) {
      this.$router.push({ name: view })
    },
    handleCreateReport () {
      // Navigate to sellout dashboard where users can create reports
      if (this.$router) {
        this.$router.push('/sellout_dashboard')
      } else {
        // Fallback to window location if router is not available
        window.location.href = '/sellout_dashboard'
      }
    },
    async fetchInitialDwStatus () {
      try {
        const dwStatusArr = await general.dwJobResultStatus()
        if (Array.isArray(dwStatusArr) && dwStatusArr.length > 0) {
          // Get the latest finished_at (in case there are multiple)
          const latest = dwStatusArr.reduce((a, b) => (a.finished_at > b.finished_at ? a : b))
          if (latest.finished_at) {
            this.lastDwUpdate = this.$moment(Number(latest.finished_at)).local().format('ddd D MMM YYYY H:mm')
          }
        }
      } catch (error) {
        console.warn('No se pudo obtener el estado inicial del Data Warehouse:', error)
      }
    },
    handleEtlJobUpdate (eventData) {
      const { status, progress, error, isWorking, isDone, hasError, finished_at: finishedAt } = eventData

      // Sincronizamos siempre el estado visual (botón, progreso, última fecha).
      this.dwJobLoading = isWorking

      if (progress !== null) {
        this.dwJobProgress = progress
      }

      this.dwJobError = hasError ? error : null

      if (isDone) {
        this.dwJobProgress = 100
      }

      if (isDone || hasError) {
        this.lastDwUpdate = finishedAt
          ? this.$moment(Number(finishedAt)).local().format('ddd D MMM YYYY H:mm')
          : this.$moment().local().format('ddd D MMM YYYY H:mm')

        setTimeout(() => {
          this.dwJobProgress = 0
        }, 3000)
      }

      // Notificamos solo eventos nuevos y en vivo:
      // - Ventana de gracia: descarta el replay de eventos previos al login.
      // - Dedupe por transición: evita repetir el mismo estado (p. ej. varios
      //   mensajes WORKING con distinto progreso, o entregas duplicadas).
      const isReplay = Date.now() < this.etlNotificationsReadyAt
      const isDuplicate = status === this.lastEtlStatus
      this.lastEtlStatus = status

      if (isReplay || isDuplicate) {
        return
      }

      if (isWorking) {
        this.$bvToast.toast('El proceso de actualización del Data Warehouse ha comenzado. Esta actualización puede incorporar nuevas ventas, modificaciones en productos o mapeos, así como ajustes en precios. Revisa el estado de carga para conocer cuándo finaliza el proceso.', {
          title: 'Actualización del Data Warehouse',
          variant: 'info',
          solid: true,
          autoHideDelay: 8000,
          toaster: 'b-toaster-top-right'
        })
      } else if (isDone) {
        this.$bvToast.toast('La actualización del Data Warehouse se ha completado exitosamente. Los nuevos datos ya están disponibles.', {
          title: 'Actualización Completada',
          variant: 'success',
          solid: true,
          autoHideDelay: 5000,
          toaster: 'b-toaster-top-right'
        })
      } else if (hasError) {
        this.$bvToast.toast(`Error durante la actualización: ${error}`, {
          title: 'Error en Actualización',
          variant: 'danger',
          solid: true,
          autoHideDelay: 8000,
          toaster: 'b-toaster-top-right'
        })
      }
    },
    startDwStatusCheck () {
      this.dwStatusInterval = setInterval(this.fetchInitialDwStatus, 300000) // 5 minutes
    },
    stopDwStatusCheck () {
      if (this.dwStatusInterval) {
        clearInterval(this.dwStatusInterval)
        this.dwStatusInterval = null
      }
    },
    async refreshDwStatus () {
      this.dwJobLoading = true
      this.dwJobProgress = 0
      this.dwJobError = null
      try {
        const dwStatus = await general.dwJobResultStatus()
        if (dwStatus && dwStatus.last_update) {
          this.lastDwUpdate = this.$moment(dwStatus.last_update).local().format('ddd D MMM YYYY h:mm A z')
        }
      } catch (error) {
        console.warn('Error al actualizar el estado del Data Warehouse:', error)
        this.dwJobError = error.message || 'Error desconocido'
      } finally {
        this.dwJobLoading = false
      }
    },
    handleModalReset () {
      // Silent refresh without toast
      this.fetchInitialDwStatus()
    }
  }
}
</script>

<style scoped>
/* Ultra-Minimal Header Like Linear/GitHub */
.app-header {
  display: flex;
  align-items: center;
  padding: 0 1rem;
  background: #ffffff;
  border-bottom: 1px solid #e2e8f0;
  position: relative;
  z-index: 1000;
  font-size: 0.875rem;
}

/* Mobile Toggle — no usar display !important para no romper d-lg-none */
.navbar-toggler {
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0 !important;
  margin-right: 0.5rem;
  background: none !important;
  border: none !important;
  border-radius: 6px;
  color: #4a5568 !important;
  font-size: 1rem !important;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
  opacity: 1 !important;
}

.navbar-toggler.d-lg-none {
  display: inline-flex;
}

.navbar-toggler:hover {
  background: #f7fafc !important;
  color: #2d3748 !important;
}

/* Brand Logo */
.navbar-brand {
  display: flex;
  align-items: center;
  margin: 0 1.5rem 0 0;
  height: 100%;
}

.brand-logo {
  height: 55px;
  width: auto;
  object-fit: contain;
  object-position: center;
}

/* Desktop Navigation */
.desktop-nav {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.nav-link {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.375rem 0.75rem;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #4a5568;
  font-size: 0.875rem;
  position: relative;
  text-decoration: none;
}

.nav-link:hover {
  background: #f7fafc;
  color: #2d3748;
}

/* Mobile Navigation */
.mobile-collapse {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: #ffffff;
  border-bottom: 1px solid #e2e8f0;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.07);
  z-index: 999;
}

.mobile-menu {
  padding: 0.5rem 0;
  display: flex;
  flex-direction: column;
}

.mobile-menu-divider {
  height: 1px;
  background: #e2e8f0;
  margin: 0.25rem 0;
}

.mobile-menu-item {
  display: flex;
  align-items: center;
  gap: 0.625rem;
  padding: 0.625rem 1rem;
  color: #4a5568;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s ease;
}

.mobile-menu-item:hover {
  background: #f7fafc;
  color: #2d3748;
}

.mobile-menu-icon {
  width: 16px;
  text-align: center;
  color: #718096;
  font-size: 0.8rem;
  flex-shrink: 0;
}

/* Reset dropdown items in mobile menu to look like nav links */
.mobile-menu >>> .nav-item {
  list-style: none;
  width: 100%;
}

.mobile-menu >>> .nav-link,
.mobile-menu >>> .dropdown-toggle {
  display: flex !important;
  align-items: center;
  width: 100%;
  padding: 0.625rem 1rem !important;
  color: #4a5568 !important;
  font-size: 0.875rem !important;
  font-weight: 500;
  text-decoration: none !important;
  border-radius: 0;
  transition: background 0.15s ease;
}

.mobile-menu >>> .nav-link:hover,
.mobile-menu >>> .dropdown-toggle:hover {
  background: #f7fafc !important;
  color: #2d3748 !important;
}

.mobile-menu >>> .dropdown-menu {
  position: static !important;
  float: none;
  border: none;
  border-left: 2px solid #e2e8f0;
  border-radius: 0;
  box-shadow: none;
  padding: 0;
  margin: 0 0 0 1rem;
  background: transparent;
}

.mobile-menu >>> .dropdown-item {
  padding: 0.5rem 1rem;
  font-size: 0.8125rem;
  color: #718096 !important;
}

.mobile-menu >>> .dropdown-item:hover {
  background: #f7fafc;
  color: #2d3748 !important;
}

/* Header Actions */
.header-actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

/* Note: .header-btn styles moved to _custom.scss for design system consistency */

/* Header Button Dropdowns */
.header-btn-dropdown {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.375rem 0.75rem;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #4a5568;
  font-size: 0.875rem;
  position: relative;
}

.header-btn-dropdown:hover {
  background: #f7fafc;
  color: #2d3748;
}

.header-btn-dropdown .btn-text {
  font-weight: 500;
  white-space: nowrap;
}

/* Button Content Layout */
.btn-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.125rem;
}

.btn-date {
  font-size: 0.625rem;
  color: #718096;
  font-weight: 400;
  line-height: 1;
}

/* Status Indicators */
.status-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  flex-shrink: 0;
}

.status-dot.success {
  background: #10b981;
}

.status-dot.error {
  background: #ef4444;
}

.status-dot.recent {
  background: #3b82f6;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}

.progress-mini {
  background: #4299e1;
  color: #ffffff;
  font-size: 0.625rem;
  font-weight: 600;
  padding: 0.125rem 0.25rem;
  border-radius: 2px;
  line-height: 1;
}

/* Account Navigation Link */
.account-nav {
  margin-left: auto;
  padding-left: 0.5rem;
}

/* Mobile Responsive */
@media (max-width: 991px) {
  .app-header {
    padding: 0 0.75rem;
    height: 44px;
  }

  .header-actions {
    gap: 0.25rem;
  }

  /* Note: .header-btn responsive styles moved to _custom.scss for design system consistency */
}

@media (max-width: 991px) {
  .navbar-brand {
    display: none;
  }
}

@media (max-width: 767px) {
  .app-header {
    padding: 0 0.5rem;
    height: 44px;
  }

  .header-btn {
    padding: 0.25rem;
  }
}

/* Remove Bootstrap defaults */
.app-header >>> .navbar-nav {
  flex-direction: row;
}

.app-header >>> .nav-link {
  padding: 0;
}

.app-header >>> .dropdown-toggle::after {
  display: none;
}

/* Override Bootstrap Vue dropdown colors to match header buttons */
.desktop-nav >>> .nav-link,
.desktop-nav >>> .nav-link:hover,
.desktop-nav >>> .nav-link:focus,
.desktop-nav >>> .nav-link:active,
.desktop-nav >>> .dropdown-toggle,
.desktop-nav >>> .dropdown-toggle:hover,
.desktop-nav >>> .dropdown-toggle:focus,
.desktop-nav >>> .dropdown-toggle:active {
  color: #4a5568 !important;
  text-decoration: none !important;
}

.desktop-nav >>> .nav-link:hover,
.desktop-nav >>> .dropdown-toggle:hover {
  background: #f7fafc !important;
  color: #2d3748 !important;
}

.desktop-nav >>> .btn-text {
  color: inherit !important;
  font-weight: 500 !important;
}
</style>

<!-- Add SVG Definitions -->
<style>
/* Global SVG Gradient (unscoped for SVG use) */
.progress-svg defs,
.progress-svg linearGradient {
  display: block;
}
</style>

<!-- Global styles: force mobile dropdown to be inline (not absolute) -->
<style>
.mobile-menu .dropdown-menu {
  position: static !important;
  float: none !important;
  border: none !important;
  border-left: 2px solid #e2e8f0 !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  padding: 0.25rem 0 !important;
  margin: 0 0 0.25rem 1.5rem !important;
  background: transparent !important;
  transform: none !important;
  display: block !important;
}

.mobile-menu .dropdown-menu .dropdown-item {
  padding: 0.5rem 1rem !important;
  font-size: 0.8125rem !important;
  color: #718096 !important;
  background: transparent !important;
}

.mobile-menu .dropdown-menu .dropdown-item:hover {
  background: #f7fafc !important;
  color: #2d3748 !important;
}
</style>

<!-- Add inline SVG for gradient -->
<svg style="position: absolute; width: 0; height: 0; overflow: hidden;">
  <defs>
    <linearGradient id="progressGradient" x1="0%" y1="0%" x2="100%" y2="0%">
      <stop offset="0%" stop-color="#4299e1" />
      <stop offset="50%" stop-color="#3b82f6" />
      <stop offset="100%" stop-color="#06b6d4" />
    </linearGradient>
  </defs>
</svg>



// WEBPACK FOOTER //
// src/app/nav_bar/BaseHeader.vue